<div class="categories container-fluid">
  <h2>{{"Discover Creations by Category"|translate}}</h2>
  <div class="grid">
    @for (rule of rulesService.rules; track $index) {
    <button class="btn btn-light rule" (click)="handleClick(rule)">
      <div class="img-wrapper">
        <app-asset [assetSrc]="rule.assetSrc"></app-asset>
      </div>
      <div class="text">
        {{rule.name}}
      </div>
    </button>
    }
  </div>
</div>
